export const FAUX_LEVEL_URL_PARAM = 'fauxDevFlagEnv';

export const e1 = 'e1';
export const e2 = 'e2';
export const e3 = 'e3';
export const CONSUMER_TRAVEL = 'CONSUMER-TRAVEL';
export const STAGING = 'STAGING';
export const TRAVEL_ISEATZ = 'TRAVEL-ISEATZ';
export const PREBOOKING = 'PREBOOKING';
